import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Curso } from '../../interfaces/curso';
import { CertificadosService } from '../../services/certificados.service';
import { CursosService } from '../../services/cursos.service';
import { PostulacionesService } from '../../services/postulaciones.service';
import { PostulantesService } from '../../services/postulantes.service';
import { SessionService } from '../../services/session.service';
import { StartService } from '../../services/start.service';
import { animations } from '../../tools/animations';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    animations: animations
})
@Sentry.TraceClassDecorator()
export class HomeComponent {

    
    public cursosDisponibles: Curso[];
    public cursosNoDisponibles: Curso[];

    public numCursosGratuitos: number = 0;
    public numPostulantes: number = 0;
    public numPostulaciones: number = 0;
    public numCertificados: number = 0;
   
    public videos: any[] = [];

    constructor(
        private cursosService: CursosService,
        private postulantesService: PostulantesService,
        private postulacionesService: PostulacionesService,
        private certificadosService: CertificadosService,
        public sessionService: SessionService,
        private startService: StartService,
        private sanitizer: DomSanitizer,
        private erroresHandler: ErroresHandler
    ) {}

    async ngOnInit() {
        try{
            this.cursosDisponibles = await this.cursosService.getCursosRecomendadosDisp();

            this.cursosNoDisponibles = await this.cursosService.getCursosRecomendadosNoDisp();

            this.numCursosGratuitos = await this.cursosService.getCantidadCursosGratuitos();

            this.numPostulaciones = await this.postulacionesService.getCantidadPostulaciones();

            this.numPostulantes = await this.postulantesService.getCantidadPostulantes();

            this.numCertificados = await this.certificadosService.getCantidadCertificados();
		
            this.startService.getVideosTutoriales().then(videos => {
                videos.forEach(video => {
                if(video.mostrar_home && video.estado){
                    let url = 'https://www.youtube.com/embed/' + video.id_video;
                    video.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);          
                    this.videos.push(video);
                }
                });
            });

        }catch(e){
            this.erroresHandler.processError(
                e,
                'alert',
                'No se puede cargar información de cursos, intentelo más tarde',
                'Error'
            );
        }
    }

}